import React, { createContext, useContext } from 'react';
import type { OrderFieldDisplay } from '../../hooks/useOrderFieldDisplay';

/**
 * Delivers the resolved order field DISPLAY state (movetype/invoiced hide &
 * readonly) to descendants of the order form — the field renders AND the
 * Change All checkboxes — so both read the same source of truth and can't
 * disagree.
 *
 * Safe default (no provider): nothing hidden / nothing readonly — i.e. today's
 * behavior. So components using this outside the order form (tests, previews)
 * are unaffected.
 */
const DEFAULT: OrderFieldDisplay = {
  ready: false,
  isFieldHidden: () => false,
  isFieldReadonly: () => false,
  isTabHidden: () => false,
  // No provider means no override either — code-level locks keep their floor.
  isFieldOverridden: () => false,
};

const Ctx = createContext<OrderFieldDisplay>(DEFAULT);

export const useOrderFieldDisplayContext = (): OrderFieldDisplay => useContext(Ctx);

export const OrderFieldDisplayProvider: React.FC<{
  value: OrderFieldDisplay;
  children: React.ReactNode;
}> = ({ value, children }) => <Ctx.Provider value={value}>{children}</Ctx.Provider>;
